import { render, staticRenderFns } from "./banner-detail.vue?vue&type=template&id=e6c81858&scoped=true&"
import script from "./banner-detail.vue?vue&type=script&lang=js&"
export * from "./banner-detail.vue?vue&type=script&lang=js&"
import style0 from "./banner-detail.vue?vue&type=style&index=0&id=e6c81858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c81858",
  null
  
)

export default component.exports